// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__ePVOM","carousel-inner":"Carousel_carousel-inner__SpsGx","carousel-item-wrap":"Carousel_carousel-item-wrap__eCAU8"};